var current_year = new Date().getFullYear();


export default current_year;